import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import {
  NewsCenterArticlesResponse,
  NewsCenterClient,
  NewsCenterQuery,
} from "@lib/ShiOneClient";
import ms from "ms";

export default function useGetNewsArticles(query: NewsCenterQuery) {
  const api = useApi(NewsCenterClient);

  const getNewsArticles = async (query: NewsCenterQuery) => {
    return await api.getNewsCenter(query);
  };

  return useQuery<NewsCenterArticlesResponse>({
    queryKey: ["message-center-articles", query],
    queryFn: () => getNewsArticles(query),
    staleTime: ms("10m"),
  });
}
